<template>
    <div class="page-content">
        <b-card :header="$t('result')">
            <b-table
                :items="tableItems"
                :fields="tableFields"
                :busy="loading"
                striped
                hover
                bordered
                responsive
                class="mt-3"
            >
                <template #table-busy>
                    <div class="text-center text-primary my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong class="ml-2">{{ $t('loading') }}...</strong>
                    </div>
                </template>

                 <template #cell(value)="data">
                    <b-badge>{{ data.value }}</b-badge>
                </template>
                <template #cell(result)="data">
                    <b-badge :variant="data.value ? 'success' : 'danger'">{{ data.value }}</b-badge>
                </template>
            </b-table>
        </b-card>
    </div>
</template>

<script>
import YoksisService from "@/services/YoksisService";

export default {
    name: "ConfirmationShow",
    data() {
        return {
            confirmationData: null,
            loading: false,

        }
    },
    computed: {
        tableFields() {
            return [
                { key: 'label', label: this.$t('key'), sortable: true, class: 'font-weight-bold' },
                { key: 'value', label: this.$t('value'), class: 'text-center' },
                { key: 'result', label: this.$t('result'), class: 'text-center' }
            ]
        },
        tableItems() {
            if (!this.confirmationData) {
                return [];
            }
            return Object.entries(this.confirmationData.data)
                .filter(([key, value]) => value !== null && value !== "")
                .map(([key, value]) => {
                    return {
                        label: key,
                        value: value,
                        result: this.confirmationData.sonuc[key]
                    };
                });
        }
    },
    created() {
        this.getConfirmationResult();
    },
    methods: {
        async getConfirmationResult() {
            this.loading = true;
            try {
                const res = await YoksisService.corfirmationResult();
                if (res.data && res.data.data) {
                    this.confirmationData = res.data.data;
                }
            } catch (error) {
                this.showErrors(error)
            } finally {
                this.loading = false;
            }
        }
    }
}
</script>

<style scoped>
.page-content {
    padding: 3px;
}
</style>
